var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CarouselSlide',{staticClass:"insurance-companies-slide"},[_c('img',{attrs:{"src":"/images/promo/interface-slider/insurance-companies-slide.png","alt":"Insurance companies statistics interface"}})])}
var staticRenderFns = []

export { render, staticRenderFns }